import React from 'react';

import {
    COVERAGE_ALIAS,
    DIGITAL_BLOCK_ALIAS,
    HYDROPHOBIC_ALIAS,
    SUNGLASSES_ALIAS,
    UV_ALIAS,
    COVERAGE_2YR_ALIAS,
} from 'constants/upsells';

import {CoatingPopupContent} from '../coatingPopupContent/coatingPopupContent';
import {Coatings as CoatingsPopup} from '../coatings/coatings';
import {InsuranceCartModal} from '../insuranceCartModal/insuranceCartModal';

import {SunglassesUpsellContent} from './components/sunglassesUpsellContent/sunglassesUpsellContent';

export type UpsellType = {
    alias: string;
    price: number;
    copayPrice: number;
    phone: string;
    specialPrice: number;
    isAdded: boolean;
    toggleUpsell: () => void;
    title: string;
    icon: string;
    onClose: (visibility: boolean) => void;
    itemId?: string;
};

/**
 * returns content for Upsell in depends on alias
 * @param {UpsellType} props - Upsell props
 * @returns {UpsellType} upsell content - content for upsell and upsell popup
 */
export const getUpsells = (props: UpsellType) => {
    switch (props.alias) {
        case UV_ALIAS:
            return {
                content: 'Provides complete protection from UV light & reduces glare',
                name: 'premium_coatings',
                needToShowPrice: true,
                popup: <CoatingsPopup />,
                title: 'UV & Anti-Reflective',
            };
        case DIGITAL_BLOCK_ALIAS:
            return {
                content: 'Protect your eyes from the emissions of digital devices',
                name: 'digital_block',
                needToShowPrice: true,
                popup: (
                    <CoatingPopupContent
                        alias={props.alias}
                        handleClick={props.toggleUpsell}
                        isSelected={props.isAdded}
                    />
                ),
                title: 'Blue Light Protection',
            };
        case COVERAGE_ALIAS:
            return {
                content: 'Protect your glasses with our 1-Year coverage plan',
                icon: props.icon,
                name: 'insurance_20_20',
                needToShowPrice: true,
                popup: <InsuranceCartModal closeModal={() => props.onClose(false)} props={props} />,
                title: props.title,
            };
        case COVERAGE_2YR_ALIAS:
            return {
                content: 'Enjoy longer protection and better value',
                icon: props.icon,
                name: 'insurance_20_20',
                needToShowPrice: true,
                popup: <InsuranceCartModal closeModal={() => props.onClose(false)} props={props} />,
                title: props.title,
            };
        case HYDROPHOBIC_ALIAS:
            return {
                content: 'Easy to clean. Keeps water, fingerprints and debris away from lenses',
                name: 'hydrophobic',
                needToShowPrice: true,
                popup: (
                    <CoatingPopupContent
                        alias={props.alias}
                        handleClick={props.toggleUpsell}
                        isSelected={props.isAdded}
                    />
                ),
                title: 'Super Hydrophobic',
            };
        case SUNGLASSES_ALIAS:
            return {
                content: (
                    <SunglassesUpsellContent
                        isAdded={props.isAdded}
                        price={props.price}
                        specialPrice={props.specialPrice}
                    />
                ),
                name: 'sunglasses',
                needToShowPrice: false,
                titleStylesForDescription: true,
            };

        default:
            return {content: '', name: ''};
    }
};
